import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Layout,
  message,
  Radio,
  Row,
  Spin,
  Upload,
  Select,
} from "antd";
import TopBar from "../../Topbar/Header";
import "./ProjectDashboard.css";
import DashboardImg from "../../../assets/img/dashbordImage.png";
import SurveyBuilderHeader from "../../../assets/img/surveyBuilderHeader.png";
import AISurveyIcon from "../../../assets/img/ai-survey-i.png";
import AISurveyBuilderIcon from "../../../assets/img/survey-builder-i.png";
import AITranslationIcon from "../../../assets/img/ai-translation-i.png";
import ProjectPeriodIcon from "../../../assets/img/projectPeriod.png";
import ChartIcon from "../../../assets/img/chart.png";
import Question from "../../../assets/img/questionsImg.png";
import Timeline from "../../../assets/img/timeline.png";
import EditProject from "../../../assets/img/edit-project.png";
import TranslationActivity from "../../../assets/img/transaltionActivity.png";
import { InboxOutlined, SaveOutlined, UploadOutlined } from "@ant-design/icons";
import { getUserRole } from "../../../hooks/getUserRoles";
import axios from "axios"; // Assuming you are using axios for API calls
import { useNavigate, useParams } from "react-router-dom";
import { get, post } from "../../../utils/apiUtils";
import Dragger from "antd/es/upload/Dragger";
import Title from "antd/es/typography/Title";
import {
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  ArcElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import SurveyLineChart from "../../../hooks/surveyLineChart";
import { Pie, Line, Bar } from "react-chartjs-2";
import TranslationVolumeChart from "../../../hooks/translateVolumeChart";
import { UserOutlined, GlobalOutlined } from "@ant-design/icons";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
);

const { Content } = Layout;

const ProjectDashboard: React.FC = () => {
  const { id: projectId } = useParams();
  const userRole = getUserRole();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForSave, setIsLoadingForSave] = useState(false);
  const [surveyType, setSurveyType] = useState("string");
  const [fileList, setFileList] = useState<any>([]);
  const [surveyData, setSurveyData] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState("start");
  const [viewOption, setViewOption] = useState<"Month" | "Week">("Month");
  const [viewOptionForChart, setViewOptionForChart] = useState<
    "Line Chart" | "Pie Chart"
  >("Line Chart");
  const [viewOptionForTranslation, setViewOptionForTranslation] = useState<
    "Month" | "Week"
  >("Month");
  const [chartType, setChartType] = useState<"line" | "pie">("line"); // State for chart type
  const [translationChartType, setTranslationChartType] = useState<
    "bar" | "pie"
  >("bar");

  const [chartData, setChartData] = useState<ChartData<"line">>({
    labels: [],
    datasets: [],
  });
  const [generatedSurveysPieData, setGeneratedSurveysPieData] = useState<any>({
    labels: [],
    datasets: [
      {
        data: [], // This will hold the counts for each label (surveys per month or week)
        backgroundColor: [], // Colors for the pie chart segments
        hoverBackgroundColor: [], // Colors for when the segments are hovered
      },
    ],
  });

  const [generatedTranslationsPieData, setGeneratedTranslationsPieData] =
    useState<any>({
      labels: [],
      datasets: [
        {
          data: [], // Data for the pie chart
          backgroundColor: [], // Colors for the pie chart segments
          hoverBackgroundColor: [],
        },
      ],
    });
  const [progress, setProgress] = useState(0);

  const [totalDays, setTotalDays] = useState(0);
  const [elapsedDays, setElapsedDays] = useState(0);

  const [isReversed, setIsReversed] = useState(false);

  const [selectedYear, setSelectedYear] = useState<string>("2024");
  const [selectedYearForTranslation, setSelectedYearForTranslation] =
    useState<string>("2024");

  const [translationData, setTranslationData] = useState<any>(null);

  const [translationVolumeData, setTranslationVolumeData] = useState<
    ChartData<"bar">
  >({
    labels: [],
    datasets: [],
  });

  const handleChartTypeChange = (e: any) => {
    setChartType(e.target.value);
  };
  const toggleReverse = () => {
    setIsReversed(!isReversed);
  };
  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        setIsLoading(true);

        const response = await get<any>(`get-surveys-for-dashboard`, {
          params: {
            language_id: "ecfb845a-86f0-476c-a4df-f101d35a96f9",
            project_id: projectId,
          },
        });
        if (response.type === "success") {
          setSurveyData(response.data);
        }
      } catch (error) {
        console.error("Error fetching survey data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchTranslationData = async () => {
      try {
        const response = await get<any>(`get-translations-for-dashboard`, {
          params: {
            project_id: projectId,
          },
        });
        if (response.type === "success") {
          setTranslationData(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch translation data:", error);
      }
    };

    fetchSurveyData();
    fetchTranslationData();
  }, [projectId]);

  useEffect(() => {
    const generateTranslationVolumeData = () => {
      if (!translationData) return;

      const { translations } = translationData.metadata;
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const weeks = ["Week 1", "Week 2", "Week 3", "Week 4"];

      const monthlyCounts = new Array(12).fill(0);
      const weeklyCounts = new Array(4).fill(0);

      translations.forEach((translation: any) => {
        const createdAt = new Date(translation.created_at);
        if (createdAt.getFullYear().toString() === selectedYearForTranslation) {
          if (viewOptionForTranslation === "Month") {
            const monthIndex = createdAt.getMonth();
            monthlyCounts[monthIndex] += 1;
          } else if (viewOptionForTranslation === "Week") {
            const weekIndex = Math.floor((createdAt.getDate() - 1) / 7);
            weeklyCounts[weekIndex] += 1;
          }
        }
      });

      setTranslationVolumeData({
        labels: viewOptionForTranslation === "Month" ? months : weeks,
        datasets: [
          {
            label: `Number of translations in ${selectedYearForTranslation}`,
            data:
              viewOptionForTranslation === "Month"
                ? monthlyCounts
                : weeklyCounts,
            backgroundColor: "rgba(75,192,192,1)",
            borderColor: "#4a1c96",
          },
        ],
      });

      setGeneratedTranslationsPieData({
        labels: months,
        datasets: [
          {
            data: monthlyCounts,
            backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
            ],
          },
        ],
      });
    };

    generateTranslationVolumeData();
  }, [translationData, selectedYearForTranslation, viewOptionForTranslation]);

  const translationVolumeChartOptions: ChartOptions<"bar"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Translation Volume Over Time",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: viewOptionForTranslation === "Month" ? "Months" : "Weeks",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Translations",
        },
        beginAtZero: true,
      },
    },
  };

  const surveyLengthDistribution = surveyData?.surveys_metadata
    ?.survey_length_distribution || {
    "5-10": 0,
    "10-20": 0,
    "20+": 0,
  };

  const totalQuantitativeQuestions =
    surveyData?.surveys_metadata?.total_quantitative_questions || 0;
  const totalQualitativeQuestions =
    surveyData?.surveys_metadata?.total_qualitative_questions || 0;

  const pieData = {
    labels: ["Quantitative", "Qualitative"],
    datasets: [
      {
        data: [totalQuantitativeQuestions, totalQualitativeQuestions],
        backgroundColor: ["#CAE2FF", "#F4D9FF"],
        hoverBackgroundColor: ["#CAE2FF", "#F4D9FF"],
      },
    ],
  };

  const pieOptions = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 18,
          },
        },
      },
    },
  };

  const [pieDataTextExcelJson, setPieDataTextExcelJson] = useState<any>({
    labels: ["Text", "Excel", "JSON"],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
        hoverBackgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
      },
    ],
  });

  // const chartOptions: ChartOptions<"line"> = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: "top",
  //     },
  //     title: {
  //       display: true,
  //       text: "Number of surveys generated over time",
  //     },
  //   },
  // };

  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Number of surveys generated over time",
      },
    },
    scales: {
      y: {
        beginAtZero: true, // y-loni me fillu prej zeros
        ticks: {
          stepSize: 1, // me kete ticks --> sigurojme qe y-loni shfaq vetem numra te plote
        },
      },
      x: {
        reverse: isReversed,
      },
    },
  };

  useEffect(() => {
    if (surveyData) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const weeks = ["Week 1", "Week 2", "Week 3", "Week 4"];

      const monthlyCounts = new Array(12).fill(0);
      const weeklyCounts = new Array(4).fill(0);

      surveyData.surveys_metadata.surveys_with_questions.forEach(
        (survey: any) => {
          const createdAt = new Date(survey.created_at);
          if (createdAt.getFullYear().toString() === selectedYear) {
            if (viewOption === "Month") {
              const monthIndex = createdAt.getMonth();
              monthlyCounts[monthIndex] += 1;
            } else if (viewOption === "Week") {
              const weekIndex = Math.floor((createdAt.getDate() - 1) / 7);
              weeklyCounts[weekIndex] += 1;
            }
          }
        }
      );

      setChartData({
        labels: viewOption === "Month" ? months : weeks,
        datasets: [
          {
            label: `Number of surveys generated in ${selectedYear}`,
            data: viewOption === "Month" ? monthlyCounts : weeklyCounts,
            fill: false,
            backgroundColor: "rgba(75,192,192,1)",
            borderColor: "#4a1c96",
          },
        ],
      });
      // Set the data for the Pie chart
      setGeneratedSurveysPieData({
        labels: viewOption === "Month" ? months : weeks, // Labels for months or weeks
        datasets: [
          {
            label: `Survey distribution in ${selectedYear}`,
            data: viewOption === "Month" ? monthlyCounts : weeklyCounts, // Same data for Pie chart
            backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
            ], // Different colors for each month/week
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
              "#FF9F40",
            ],
          },
        ],
      });
    }
  }, [surveyData, viewOption, selectedYear]);

  useEffect(() => {
    if (projectId) {
      localStorage.setItem("currentProjectId", projectId);
    }
  }, [projectId]);

  const handleClearAll = () => {
    setSelectedYear("2024");
    setViewOption("Month");
    setViewOptionForChart("Line Chart");
  };

  const handleClearAllForTranslation = () => {
    setSelectedYearForTranslation("2024");
    setViewOptionForTranslation("Month");
  };

  useEffect(() => {
    const projectMetadata = surveyData?.project_metadata || {};
    const { project_start_date, project_end_date } = projectMetadata;

    const startDate = project_start_date ? new Date(project_start_date) : null;
    const endDate = project_end_date ? new Date(project_end_date) : null;
    const today = new Date();

    let calculatedTotalDays = 0;
    let calculatedElapsedDays = 0;

    if (startDate && endDate) {
      if (selectedDate === "start") {
        calculatedTotalDays =
          (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24); //Llogaritet si diferenca në kohë midis endDate dhe startDate, pastaj konvertohet nga milisekonda në ditë (ndarë për 1000 * 3600 * 24).
        calculatedElapsedDays =
          (today.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
      } else if (selectedDate === "end") {
        calculatedTotalDays =
          (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
        calculatedElapsedDays =
          (endDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
      }

      setTotalDays(calculatedTotalDays);
      setElapsedDays(calculatedElapsedDays);

      const remainingDays = Math.max(
        calculatedTotalDays - calculatedElapsedDays,
        0
      );
      const calculatedProgress = Math.min(
        Math.max((calculatedElapsedDays / calculatedTotalDays) * 100, 0),
        100
      );

      setProgress(calculatedProgress);

      console.log("Start Date:", startDate);
      console.log("End Date:", endDate);
      console.log("Today:", today);
      console.log("Total Days:", calculatedTotalDays);
      console.log("Elapsed Days:", calculatedElapsedDays);
      console.log("Remaining Days:", remainingDays);
    }
  }, [surveyData, selectedDate]);

  const projectMetadata = surveyData?.project_metadata || {};
  const {
    project_name = "No Project Name",
    project_description,
    project_manager_name,
    country_name,
    project_start_date,
    project_end_date,
  } = projectMetadata;

  useEffect(() => {
    if (translationData) {
      const { translation_counts } = translationData;
      setPieDataTextExcelJson({
        labels: ["Text", "Excel", "JSON"],
        datasets: [
          {
            data: [
              translation_counts["text type"] || 0,
              translation_counts["excel type"] || 0,
              translation_counts["json type"] || 0,
            ],
            backgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
            hoverBackgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
          },
        ],
      });
    }
  }, [translationData]);

  const translationCounts = translationData?.translation_counts || {
    "text type": 0,
    "excel type": 0,
    "json type": 0,
  };

  const redirectToProjectListWithEdit = () => {
    const workspaceId = localStorage.getItem("currentWorkspaceId");
    if (workspaceId) {
      navigate(`/projects/${workspaceId}`, {
        state: { projectId: projectId, openEditModal: true },
      });
    }
  };

  return (
    <div className="project-dashboard-layout" style={{ marginLeft: 0 }}>
      <Button
        onClick={() => window.print()}
        type="primary"
        style={{ margin: "10px" }}
      >
        Print Dashboard
      </Button>

      <Content
        className="site-layout-background"
        style={{
          padding: "0 24",
          margin: 0,
          minHeight: 280,
        }}
      >
        <div className="first-container">
          <div className="first-innerContainer">
            <h2 className="project-dashboard-title">Project Dashboard</h2>
            <h4 className="project-dashboard-subtitle">Quick action</h4>
            <div
              className="first-card-Ai"
              // style={{
              //   display: "flex",
              //   justifyContent: "space-between",
              // }}
            >
              <div className="ai-survey-tools-card">
                <img
                  src={AISurveyIcon}
                  alt="Survey generator"
                  // style={{ width: "60px", height: "60px" }}
                />
                <a
                  href={`/ai-survey-generator/${projectId}`}
                  className="card-text"
                >
                  AI Survey Generator
                </a>
              </div>
              <div className="ai-survey-tools-card">
                <img src={AISurveyBuilderIcon} alt="Survey generator" />
                <a href={`/upload-survey/${projectId}`} className="card-text">
                  Survey Builder
                </a>
              </div>{" "}
              <div className="ai-survey-tools-card">
                <img src={AITranslationIcon} alt="Survey generator" />
                <a href={`/ai-translation/${projectId}`} className="card-text">
                  AI Translation
                </a>
              </div>
            </div>
          </div>
          {/* <div className="second-innerContainer">
              <div className="second-innerContainer-part">
                <h2>{project_name}</h2>
                <p>
                  {project_description ??
                    "If project description is provided, it goes here. If there is no project description, remove this space completely ans show only the tags below"}
                </p>
                <div className="second-innerContainer-div">
                  <div className="second-innerContainer-content">
                    <UserOutlined />
                    <span>{project_manager_name}</span>
                  </div>
                  <div className="second-innerContainer-content">
                    <GlobalOutlined />
                    <span>{country_name}</span>
                  </div>
                </div>
              </div>
              <div className="second-inner-content">
                <img
                  src={EditProject}
                  alt="edit project"
                  style={{ width: "40px", height: "40px" }}
                  onClick={redirectToProjectListWithEdit}
                />
              </div>
            </div> */}
          <div className="second-innerContainer">
            {isLoading ? (
              <div style={{ color: "white" }}>Loading...</div>
            ) : (
              <>
                <div className="second-innerContainer-part">
                  <h2>{project_name}</h2>
                  <p>
                    {project_description ??
                      "If project description is provided, it goes here. If there is no project description, remove this space completely and show only the tags below"}
                  </p>
                  <div className="second-innerContainer-div">
                    <div className="second-innerContainer-content">
                      <UserOutlined />
                      <span>{project_manager_name}</span>
                    </div>
                    <div className="second-innerContainer-content">
                      <GlobalOutlined />
                      <span>{country_name}</span>
                    </div>
                  </div>
                </div>
                <div className="second-inner-content">
                  <img
                    src={EditProject}
                    alt="edit project"
                    style={{ width: "40px", height: "40px" }}
                    onClick={redirectToProjectListWithEdit}
                  />
                </div>
              </>
            )}
          </div>

          <div className="third-innerContainer">
            <div className="project-period-style">
              <div className="project-period-content-style">
                <div className="project-period-innerContent">
                  <img src={ProjectPeriodIcon} alt="projectperiod" />
                  <h2>Project Period</h2>
                </div>
                <div className="first-date-row">
                  <Radio.Group
                    onChange={(e) => setSelectedDate(e.target.value)}
                    value={selectedDate}
                  >
                    <Radio value="start">
                      <span className="date-label">Start date</span>
                    </Radio>
                    <Radio value="end" className="end-date-radio">
                      <span className="date-label">End date</span>
                    </Radio>
                  </Radio.Group>
                </div>
                <div className="first-date-row">
                  <span
                    className={`date-value ${
                      selectedDate === "start" ? "selected" : ""
                    }`}
                  >
                    {project_start_date}
                  </span>
                  <span
                    className={`date-value ${
                      selectedDate === "end" ? "selected" : ""
                    }`}
                  >
                    {project_end_date}
                  </span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="first-progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <div className="completion">
                    <span>{Math.round(progress / 10)}/10</span>
                    <br /> Overall Completed
                  </div>{" "}
                </div>
              </div>
            </div>
            <div
              className="project-period-style"
              // style={{
              //   backgroundColor: "white",
              //   width: "100%",
              //   height: "180px",
              //   padding: "13px 20px",
              //   borderRadius: "8px",
              //   boxShadow: "0px 4px 12px rgba(165.27, 176.71, 216.75, 0.80)",
              // }}
            >
              <div
                style={{
                  gap: "5px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="project-period-innerContent">
                  <img src={Timeline} alt="projectperiod" />
                  <h2>Timeline</h2>
                </div>
                <div className="remaining-time-text">
                  <span>
                    {Math.round(Math.max(totalDays - elapsedDays, 0))} days
                  </span>{" "}
                  Remaining time
                </div>

                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>

                <div className="date-row">
                  <span className="date-value">
                    {project_start_date} <br />
                    Start{" "}
                  </span>
                  <span className="date-value">
                    {project_end_date} <br />
                    End{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <img
              src={SurveyBuilderHeader}
              alt="Survey Builder"
              style={{ width: "100%" }}
            /> */}
        </div>

        <div className="first-container">
          <div className="second-inner-container">
            <h2 className="project-dashboard-title">
              AI Survey Generator activity snapshot
            </h2>
            <div className="ai-survey-generator-div">
              <div
                className="first-survey-length"
                // style={{
                //   backgroundColor: "#fafbff",
                //   display: "flex",
                //   alignItems: "center",
                //   justifyContent: "center",
                //   gap: "1rem",
                //   width: "307px",
                //   height: "128px",
                //   borderRadius: "8px",
                //   border: "1px solid #A072EB",
                //   boxShadow: "0px 4px 16px rgba(18.99, 29.78, 69.06, 0.10)",
                // }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <span className="card-text-2">
                    {surveyLengthDistribution["5-10"]}
                  </span>
                  <span className="card-text-3">5-10 Questions for Survey</span>
                </div>
                <img src={Question} alt="Survey generator" />
              </div>
              <div className="first-survey-length">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <span className="card-text-2">
                    {surveyLengthDistribution["10-20"]}
                  </span>
                  <span className="card-text-3">
                    10-20 Questions for Survey
                  </span>
                </div>
                <img src={Question} alt="Survey generator" />
              </div>{" "}
              <div className="first-survey-length">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <span className="card-text-2">
                    {surveyLengthDistribution["20+"]}
                  </span>
                  <span className="card-text-3">20+ Questions for Survey</span>
                </div>{" "}
                <img src={Question} alt="Survey generator" />
              </div>
            </div>
            <div
              style={{
                marginTop: "2rem",
                border: "1px solid #E6E6E6",
              }}
            >
              <div className="surve-generated-overtime">
                <h2 className="project-dashboard-title">
                  Number of surveys generated over time
                </h2>
                <div className="select-time">
                  <Select
                    value={selectedYear}
                    onChange={(value) => setSelectedYear(value)}
                    style={{
                      width: "150px",
                      marginRight: 16,
                    }}
                  >
                    <Select.Option value="2023">2023</Select.Option>
                    <Select.Option value="2024">2024</Select.Option>
                    <Select.Option value="2025">2025</Select.Option>
                  </Select>
                  <Radio.Group
                    value={viewOption}
                    onChange={(e) => setViewOption(e.target.value)}
                    buttonStyle="solid"
                    style={{ marginBottom: "2rem" }}
                  >
                    <Radio.Button
                      value="Month"
                      style={
                        viewOption === "Month"
                          ? {
                              backgroundColor: "unset",
                              color: "#4A1C96",
                              border: "1px solid #4A1C96",
                            }
                          : {}
                      }
                    >
                      Month
                    </Radio.Button>
                    <Radio.Button
                      value="Week"
                      style={
                        viewOption === "Week"
                          ? {
                              backgroundColor: "unset",
                              color: "#4A1C96",
                              border: "1px solid #4A1C96",
                            }
                          : {}
                      }
                    >
                      Week
                    </Radio.Button>
                  </Radio.Group>

                  <Button
                    type="link"
                    onClick={handleClearAll}
                    style={{ color: "#007BFF" }}
                  >
                    Clear all
                  </Button>
                </div>
              </div>
              <div className="chart-selector">
                <h2>Select Chart Type</h2>
                <Radio.Group
                  onChange={handleChartTypeChange}
                  value={chartType}
                  // buttonStyle="solid"
                >
                  <Radio.Button
                    value="line"
                    style={
                      viewOptionForChart === "Line Chart"
                        ? {
                            backgroundColor: "unset",
                            color: "#4A1C96",
                            // border: "1px solid #4A1C96",
                          }
                        : {}
                    }
                  >
                    Line Chart
                  </Radio.Button>
                  <Radio.Button
                    value="pie"
                    style={
                      viewOptionForChart === "Pie Chart"
                        ? {
                            backgroundColor: "unset",
                            color: "#4A1C96",
                            // border: "1px solid #4A1C96",
                          }
                        : {}
                    }
                  >
                    Pie Chart
                  </Radio.Button>
                </Radio.Group>
                <Button onClick={toggleReverse} type="primary">
                  {isReversed ? "Normal Order" : "Reverse Order"}
                </Button>
              </div>

              <div className="chart-container">
                {chartType === "line" ? (
                  <SurveyLineChart data={chartData} options={chartOptions} />
                ) : (
                  <Pie
                    data={generatedSurveysPieData}
                    options={pieOptions}
                    className="generated-survey-pie"
                  />
                )}
              </div>
              {/* <SurveyLineChart data={chartData} options={chartOptions} /> */}
            </div>
          </div>
        </div>

        <div className="first-container">
          <div className="third-inner-container">
            <h2 className="project-dashboard-title">
              Survey Builder activity snapshot
            </h2>
            <div className="survey-builder-activity-div">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "2rem",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  className="cards-for-translation"
                  // style={{
                  //   backgroundColor: "#fafbff",
                  //   display: "flex",
                  //   alignItems: "center",
                  //   justifyContent: "center",
                  //   gap: "1rem",
                  //   width: "307px",
                  //   height: "128px",
                  //   borderRadius: "8px",
                  //   border: "1px solid #A072EB",
                  //   boxShadow: "0px 4px 16px rgba(18.99, 29.78, 69.06, 0.10)",
                  // }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <span className="card-text-2">
                      {totalQuantitativeQuestions}
                    </span>
                    <span className="card-text-3">Quantitative questions</span>
                  </div>
                  <img
                    src={ChartIcon}
                    alt="Survey generator"
                    style={{ width: "60px", height: "60px" }}
                  />
                </div>

                <div
                  className="cards-for-translation"
                  // style={{
                  //   backgroundColor: "#fafbff",
                  //   display: "flex",
                  //   alignItems: "center",
                  //   justifyContent: "center",
                  //   gap: "1rem",
                  //   width: "307px",
                  //   height: "128px",
                  //   borderRadius: "8px",
                  //   border: "1px solid #A072EB",
                  //   boxShadow: "0px 4px 16px rgba(18.99, 29.78, 69.06, 0.10)",
                  // }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <span className="card-text-2">
                      {totalQualitativeQuestions}
                    </span>
                    <span className="card-text-3">Qualitative questions</span>
                  </div>{" "}
                  <img
                    src={ChartIcon}
                    alt="Survey generator"
                    style={{ width: "60px", height: "60px" }}
                  />
                </div>
              </div>
              <div className="pie-style">
                <Pie
                  data={pieData}
                  style={{ width: "231px", height: "231px" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* e fudit */}
        <div className="first-container">
          <div className="third-inner-container">
            <h2 className="project-dashboard-title">
              AI Translation activity snapshot
            </h2>
            <div className="ai-translation-activity-div">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "2rem",
                  // justifyContent: "space-between",
                }}
              >
                <div className="cards-for-translation">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <span className="card-text-2">
                      {translationCounts["text type"]}
                    </span>
                    <span className="card-text-3">Text</span>
                  </div>
                  <img
                    src={TranslationActivity}
                    alt="Survey generator"
                    style={{ width: "60px", height: "60px" }}
                  />
                </div>

                <div className="cards-for-translation">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <span className="card-text-2">
                      {translationCounts["excel type"]}
                    </span>
                    <span className="card-text-3">Excel</span>
                  </div>{" "}
                  <img
                    src={TranslationActivity}
                    alt="Survey generator"
                    style={{ width: "60px", height: "60px" }}
                  />
                </div>

                <div className="cards-for-translation">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <span className="card-text-2">
                      {translationCounts["json type"]}
                    </span>
                    <span className="card-text-3">Json</span>
                  </div>{" "}
                  <img
                    src={TranslationActivity}
                    alt="Survey generator"
                    style={{ width: "60px", height: "60px" }}
                  />
                </div>
              </div>
              <div className="pieDataTextExcelJson-style">
                <Pie
                  data={pieDataTextExcelJson}
                  options={pieOptions}
                  style={{ width: "231px", height: "231px" }}
                />
              </div>
            </div>
            <div style={{ border: "1px solid #E6E6E6", borderRadius: "8px" }}>
              <div style={{ padding: "2rem" }}>
                <div className="translation-volume-overtime">
                  <h2>Translation Volume Over Time</h2>
                  <div className="select-time-fortranslation">
                    <Select
                      value={selectedYearForTranslation}
                      onChange={(value) => setSelectedYearForTranslation(value)}
                      style={{
                        width: "150px",
                        marginRight: 16,
                      }}
                    >
                      <Select.Option value="2023">2023</Select.Option>
                      <Select.Option value="2024">2024</Select.Option>
                      <Select.Option value="2025">2025</Select.Option>
                    </Select>
                    <Radio.Group
                      value={viewOptionForTranslation}
                      onChange={(e) =>
                        setViewOptionForTranslation(e.target.value)
                      }
                      buttonStyle="solid"
                    >
                      <Radio.Button
                        value="Month"
                        style={
                          viewOptionForTranslation === "Month"
                            ? {
                                backgroundColor: "unset",
                                color: "#4A1C96",
                                border: "1px solid #4A1C96",
                              }
                            : {}
                        }
                      >
                        Month
                      </Radio.Button>
                      <Radio.Button
                        value="Week"
                        style={
                          viewOptionForTranslation === "Week"
                            ? {
                                backgroundColor: "unset",
                                color: "#4A1C96",
                                border: "1px solid #4A1C96",
                              }
                            : {}
                        }
                      >
                        Week
                      </Radio.Button>
                    </Radio.Group>

                    <Button
                      type="link"
                      onClick={handleClearAllForTranslation}
                      style={{ color: "#007BFF" }}
                    >
                      Clear all
                    </Button>
                  </div>
                </div>
                <div className="chart-selector">
                  <h2>Select Translation Chart Type</h2>
                  <Radio.Group
                    onChange={(e) => setTranslationChartType(e.target.value)}
                    value={translationChartType}
                    buttonStyle="solid"
                  >
                    <Radio.Button
                      value="bar"
                      style={
                        viewOptionForChart === "Pie Chart"
                          ? {
                              backgroundColor: "unset",
                              color: "#4A1C96",
                              border: "1px solid #4A1C96",
                            }
                          : {}
                      }
                    >
                      Bar Chart
                    </Radio.Button>
                    <Radio.Button value="pie">Pie Chart</Radio.Button>
                  </Radio.Group>
                </div>
                <div>
                  {translationChartType === "bar" ? (
                    <TranslationVolumeChart
                      data={translationVolumeData}
                      options={translationVolumeChartOptions}
                    />
                  ) : (
                    <Pie
                      data={generatedTranslationsPieData}
                      options={pieOptions}
                      className="generated-survey-pie"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </div>
  );
};

export default ProjectDashboard;
